<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-23 16:19:38
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    title="排除客户"
    :visible="true"
    width="85%"
    :append-to-body="true"
    :before-close="handleClose"
  >
    <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
      <div class="tips">
        提示：添加到列表中的经销商/门店无法查看、订购此商品
      </div>
      <el-tab-pane label="选择经销商" name="first">
        <el-button
          type="primary"
          size="small"
          @click="selectDealer = !selectDealer"
          >添加经销商</el-button
        >
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          height="250"
          border
          stripe
          style="width: 100%;margin: 20px 0"
          @selection-change="select"
        >
          <el-table-column type="selection" v-if="selects" width="50">
          </el-table-column>

          <el-table-column
            prop="dealer_sn"
            label="经销商编号"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dealer_name"
            width="180"
            label="经销商名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="level_name"
            label="经销商级别"
            width="180"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="person" label="负责人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop=""
            label="操作"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="delDealer(scope.row, 'dealer')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-button size="small" @click="allDel()">批量删除</el-button>

        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="选择门店" name="second">
        <el-button
          type="primary"
          size="small"
          @click="selectStore = !selectStore"
          >添加门店</el-button
        >
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData2"
          v-loading="loading"
          height="250"
          border
          @selection-change="select"
          style="width: 100%;margin: 20px 0"
        >
          <el-table-column type="selection" width="55" v-if="selects">
          </el-table-column>
          <el-table-column
            prop="shop_sn"
            label="门店编号"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="shop_name"
            width="180"
            label="门店名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="门店地址"
            width="180"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="person" label="负责人" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="isself" label="类型" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop=""
            label="操作"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="delStore(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-button size="small" @click="allDel()">批量删除</el-button>

        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="confrim">确 定</el-button>
    </span>
    <selectStore
      v-if="selectStore"
      v-on:handleClose="Close"
      @pushData="getSelectStore"
      :selects="true"
      :putaway="putaway"
      @selsects="getSelectStore"
    />
    <selectDealer
      v-if="selectDealer"
      v-on:handleClose="Close"
      @pushData="getSelectDealer"
      :selects="true"
      :putaway="putaway"
      @selsects="getSelectDealer"
    />
  </el-dialog>
</template>

<script>
import selectStore from "./selectStore";
import selectDealer from "./selectDealer";
import { isArray } from "util";
import { setTimeout } from "timers";
export default {
  name: "selectRole",
  data() {
    return {
      selectDealer: false,
      selectStore: false,
      loading: false,
      activeName2: "first",
      form: {
        dealer_sn: "",
        dealer_name: "",
        keywords: "",
      },
      form1: {
        shop_name: "",
        shop_sn: "",
        isself: "",
        keywords: "",
      },
      storeArr: [
        {
          label: "全部",
          id: "",
        },
        {
          label: "直营门店",
          id: 1,
        },
        {
          label: "非直营门店",
          id: 2,
        },
      ], //门店类型
      tableData1: [],
      tableData2: [],
      multipleSelection: [],
      //经销商分页
      pageNo1: 1, //页码
      pageSize1: 20, //每页现实的条数
      totalSize1: 0, //总条数
      //门店分页
      pageNo2: 1, //页码
      pageSize2: 10, //每页现实的条数
      totalSize2: 0, //总条数
      selectData: [],
      is_select: this.select, //是否开启全选
      type: "dealer",
      puta: {},
    };
  },
  props: {
    selects: Boolean,
    putaway: Object,
  },
  methods: {
    init() {
      this.tableData2 = [];
      this.tableData1 = [];
      this.$get(
        "logistics",
        "/product.putaways/" + this.putaway.putaway_id
      ).then((res) => {
        this.puta = res.data;
        this.putaway = res.data;
        this.getDealer();
        this.getStore();
      });
    },
    // selectDealer
    select(value) {
      if (this.activeName2 === "first") {
        this.type = "dealer";
      } else {
        this.type = "store";
      }
      this.selectData = value;
    },
    // 获取弹出层的 经销商信息
    getSelectDealer(value) {
      if (isArray(value)) {
        if (value.length > 0) {
          var url = "/product.putaways/" + this.puta.putaway_id + "/sexclude";
          var dealer_sn = [];
          value.forEach((element) => {
            dealer_sn.push(element.dealer_sn);
          });
          this.$post("logistics", url, {
            exclude_sns: dealer_sn,
            exclude_type: 2,
          })
            .then((res) => {
              this.$message({
                type: "info",
                message: "成功",
              });
              this.init();
            })
            .catch(function(error) {});
        }
      } else {
        var url = "/product.putaways/" + this.puta.putaway_id + "/sexclude";
        this.$post("logistics", url, {
          exclude_sns: [value.dealer_sn],
          exclude_type: 2,
        })
          .then((res) => {
            this.$message({
              type: "info",
              message: "成功",
            });
            this.init();
          })
          .catch(function(error) {});
      }
    },
    getSelectStore(value) {
      //  console.log(value)
      if (isArray(value)) {
        if (value.length > 0) {
          var url = "/product.putaways/" + this.puta.putaway_id + "/sexclude";
          var shop_sn = [];
          value.forEach((element) => {
            shop_sn.push(element.shop_sn);
          });
          this.$post("logistics", url, {
            exclude_sns: shop_sn,
            exclude_type: 3,
          })
            .then((res) => {
              this.$message({
                type: "info",
                message: "成功",
              });
              this.init();
            })
            .catch(function(error) {});
        }
      } else {
        var url = "/product.putaways/" + this.puta.putaway_id + "/sexclude";
        this.$post("logistics", url, {
          exclude_sns: [value.shop_sn],
          exclude_type: 3,
        })
          .then((res) => {
            this.$message({
              type: "info",
              message: "成功",
            });
            this.init();
          })
          .catch(function(error) {});
      }
    },
    // delDealer 删除客户排除
    delDealer(data, temp) {
      var sn = "";
      if (temp == "dealer") {
        sn = data.dealer_sn;
      } else {
        sn = data.shop_sn;
      }

      var url = "/product.putaways/" + this.puta.putaway_id + "/dexclude";
      this.$post("logistics", url, {
        exclude_sns: [sn],
        exclude_type: 2,
      })
        .then((res) => {
          this.$message({
            type: "info",
            message: "成功",
          });
          this.init();
        })
        .catch(function(error) {});
    },
    //批量删除 经销商
    allDel() {
      var exclude_type = 2;
      var snArr = [];
      if (this.type === "dealer") {
        this.selectData.forEach((element) => {
          snArr.push(element.dealer_sn);
        });
      } else {
        exclude_type = 3;
        this.selectData.forEach((element) => {
          snArr.push(element.shop_sn);
        });
      }
      var url = "/product.putaways/" + this.puta.putaway_id + "/dexclude";
      this.$post("logistics", url, {
        exclude_sns: snArr,
        exclude_type: exclude_type,
      })
        .then((res) => {
          this.$message({
            type: "info",
            message: "成功",
          });
          this.init();
        })
        .catch(function(error) {
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    delStore(data) {
      var url = "/product.putaways/" + this.puta.putaway_id + "/dexclude";
      this.$post("logistics", url, {
        exclude_sns: [data.shop_sn],
        exclude_type: 3,
      })
        .then((res) => {
          this.$message({
            type: "info",
            message: "成功",
          });
          this.init();
        })
        .catch(function(error) {});
    },
    //确认
    confrim() {
      if (this.selectData.length == 0) {
        this.handleClose();
        return;
      }
      if (this.type == "dealer") {
        var exclude_sns = [];
        this.selectData.forEach((element) => {
          exclude_sns.push(element.dealer_sn);
        });
        var url = "/product.putaways/" + this.puta.putaway_id + "/dexclude";
        this.$post("logistics", url, {
          exclude_sns: exclude_sns,
          exclude_type: 2,
        })
          .then((res) => {
            this.$message({
              type: "info",
              message: "成功",
            });
            this.handleClose();
          })
          .catch(function(error) {});
      } else {
        var exclude_sns = [];
        var url = "/product.putaways/" + this.puta.putaway_id + "/dexclude";
        this.selectData.forEach((element) => {
          exclude_sns.push(element.shop_sn);
        });
        this.$post("logistics", url, {
          exclude_sns: exclude_sns,
          exclude_type: 3,
        })
          .then((res) => {
            this.$message({
              type: "info",
              message: "成功",
            });
            this.handleClose();
          })
          .catch(function(error) {});
      }
    },
    //查询经销商
    getDealer() {
      var _this = this;

      if (this.putaway.exclude_dealers.length == 0) {
        this.loading = false;
        return;
      }
      this.loading = true;

      this.$post("logistics", "/dealers.batchs", {
        dealer_sns: this.puta.exclude_dealers.join(),
        per_page: this.pageSize1,
        page: this.pageNo1,
      })
        .then((res) => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
        })
        .catch(function(error) {
          _this.loading = false;
        });
    },
    //选择经销商
    chooseDealer(row) {
      this.$emit("pushData", row);
      this.$emit("handleClose");
    },
    //选择门店
    chooseStore(row) {
      this.$emit("pushData", row);
      this.$emit("handleClose");
    },
    //查询门店
    getStore() {
      var _this = this;

      this.loading = true;
      // exclude_shops
      this.$post("logistics", "/shops.batchs", {
        per_page: this.pageSize2,
        page: this.pageNo2,
        shop_sns: this.puta.exclude_shops.join(),
      })
        .then((res) => {
          this.loading = false;
          this.tableData2 = res.data;
          this.totalSize2 = res.meta.total;
        })
        .catch(function(error) {
          _this.loading = false;
        });
    },
    handleClick(tab, event) {
      //console.log(tab, event);
      this.selectData = [];
      this.type = null;
    },
    /*分页*/
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      this.getDealer();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.getDealer();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.getStore();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.getStore();
    },
    handleClose() {
      this.$emit("handleClose");
    },
    Close() {
      this.selectStore = false;
      this.selectDealer = false;
      var _this = this;

      this.init();
    },
  },
  created() {
    this.init();
  },
  components: {
    selectDealer,
    selectStore,
  },
};
</script>

<style lang="scss" scoped>
.tips {
  padding: 15px;
  background-color: #eee;
  margin-bottom: 5px;
}
</style>
